import { useCallback } from 'react';
import { useAnalyticsContext } from '../../../../context/analytics-context/analytics-context';
import { useAppContext } from '../../../../context/app-context';
import { setAllDrawersClosed } from '../../../../context/app-context/app-context-actions';
import { useUIStore } from '../../../../stores/ui';
import { discardTextObjectAndRender } from '../../../../utils';

export const useCloseFontDrawer = () => {
  const { trackTextEdits } = useAnalyticsContext();
  const { appDispatch } = useAppContext();
  const closeTextDrawer = useUIStore((state) => state.closeTextDrawer);

  const onFontDrawerSubmit = useCallback(
    (canvas) => {
      const activeObject = canvas?.current?.getActiveObject();
      if (activeObject) {
        trackTextEdits(activeObject);
      }
      onFontDrawerClose(canvas);
    },
    [appDispatch],
  );

  const onFontDrawerClose = useCallback(
    (canvas) => {
      if (canvas?.current) {
        discardTextObjectAndRender(canvas.current);
      }
      setAllDrawersClosed(appDispatch);
      closeTextDrawer();
    },
    [appDispatch, closeTextDrawer],
  );

  return {
    onFontDrawerSubmit,
    onFontDrawerClose,
  };
};
